import { render } from "./CadastroVeiculoTrator.vue?vue&type=template&id=5cc84a02"
import script from "./CadastroVeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./CadastroVeiculoTrator.vue?vue&type=script&lang=ts"
script.render = render

export default script